module.exports = {
	"default": "en2",
	"langs": [
		{
			"value": "zh-cn2",
			"text": "中文（Vue 2.0 版）"
		},
		{
			"value": "en2",
			"text": "English (for Vue 2.0)"
		},
		{
			"value": "zh-cn",
			"text": "中文"
		},
		{
			"value": "en",
			"text": "English"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/langs.json
// module id = 67
// module chunks = 128